import { mutatorAction } from 'satcheljs';
import type DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';
import getDensityOptionState from '../store/store';

export const displayDensityOptionSelectedMutator: (
    newDensityModeSelected: DisplayDensityMode
) => void = mutatorAction(
    'DISPLAY_DENSITY_OPTION_SELECTED',
    function displayDensityOptionSelected(newDensityModeSelected: DisplayDensityMode): void {
        const densityOption = getDensityOptionState();
        densityOption.densityModeSelected = newDensityModeSelected;
    }
);

export const messageListLineOptionSelectedMutator: (showSingleLineView: boolean) => void =
    mutatorAction(
        'MESSAGE_LIST_LINE_OPTION_SELECTED',
        function messageListLineOptionSelected(showSingleLineView: boolean): void {
            const densityOption = getDensityOptionState();
            densityOption.useSingleLineMessageStyle = showSingleLineView;
        }
    );

export const discardDensityOptionMutator: () => void = mutatorAction(
    'DISCARD_DENSITY_OPTION',
    function discardDensityOption(): void {
        getDensityOptionState().densityModeSelected = null;
        getDensityOptionState().useSingleLineMessageStyle = null;
    }
);
